import React, { useContext, useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import { Box, Drawer, Hidden } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { useTheme } from '@mui/material/styles'
import CategoryDisplayer from '../../CategoryDisplayer'
import Dialog from '../Dialog'
import ContactHome from '../../ContactHome/ContactHome'
import ProfileContext from '@/components/Context/ProfileContext'

type Props = {
  isInMaintenance: boolean
  openDrawer: boolean
  setOpenDrawer: (open: boolean) => void
}
const Header: React.FC<Props> = ({ isInMaintenance, openDrawer, setOpenDrawer }) => {
  const theme = useTheme()
  const router = useRouter()
  const [dialog, setDialog] = useState<boolean>(false)

  const { isAuthenticated } = useContext(ProfileContext)

  // Ferme le drawer mobile des qu'une navigation demarre (clic sur un lien du menu)
  useEffect(() => {
    const closeDrawer = () => setOpenDrawer(false)
    router.events.on('routeChangeStart', closeDrawer)

    return () => router.events.off('routeChangeStart', closeDrawer)
  }, [router.events, setOpenDrawer])

  const displayMenuCategory =
    isAuthenticated || (!isAuthenticated && router.route !== '/[locale]/home')

  return (
    <>
      <Dialog onClose={() => setDialog(false)} open={!!dialog}>
        <ContactHome />
      </Dialog>

      {!isInMaintenance && (
        <Box>
          {displayMenuCategory && (
            <>
              <Hidden mdDown>
                <CategoryDisplayer key={'desktop'} />
              </Hidden>
            </>
          )}
        </Box>
      )}
      <Drawer open={openDrawer} onClose={() => setOpenDrawer(false)}>
        <>
          <div
            className="flex justify-between items-center h-8 px-4 text-white"
            style={{ backgroundColor: theme.palette.primary.main }}
          >
            <div>MENU</div>
            <CloseIcon onClick={() => setOpenDrawer(false)} />
          </div>

          <div style={{ width: '100vw' }}>
            <CategoryDisplayer key={'mobile'} mobile />
          </div>
        </>
      </Drawer>
    </>
  )
}
export default Header
